import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { useQuery } from "@apollo/client";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { useTranslation } from "react-i18next";
import { GET_DOCUMENT } from "@/queries/GetDocument";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { DownloadDocument } from "@/resources/User/DownloadDocument";
import { REPORT_MANIFEST_FILE_NAME, reportManifestDocumentId } from "@/lib/reportManifest";
import { DownloaButton } from "./styles/WidgetStyle";
/**
 * Downloads the hash manifest of a generated report. It shows only for a
 * report that was stored with one.
 */
export var ReportManifestDownload = function (_a) {
    var _b, _c;
    var documentId = _a.documentId, electionEventId = _a.electionEventId, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var _e = useState(false), downloading = _e[0], setDownloading = _e[1];
    var data = useQuery(GET_DOCUMENT, {
        variables: { id: documentId, tenantId: tenantId },
        skip: !documentId || !tenantId || disabled,
    }).data;
    var manifestDocumentId = reportManifestDocumentId((_c = (_b = data === null || data === void 0 ? void 0 : data.sequent_backend_document) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.annotations);
    if (!manifestDocumentId) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(DownloaButton, { onClick: function () { return setDownloading(true); }, disabled: disabled || downloading, label: String(t("tasksScreen.widget.downloadHashManifest")), children: _jsx(FingerprintIcon, {}) }), downloading ? (_jsx(DownloadDocument, { documentId: manifestDocumentId, electionEventId: electionEventId !== null && electionEventId !== void 0 ? electionEventId : undefined, fileName: REPORT_MANIFEST_FILE_NAME, onDownload: function () { return setDownloading(false); } })) : null] }));
};
